import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const CmsWelcomeSection = ({ content, onChange }) => {
  const welcome = content?.welcome || {};

  const updateWelcome = (field, value) => {
    onChange({
      ...content,
      welcome: { ...welcome, [field]: value },
    });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-romantic-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="MessageCircle" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Guest Welcome Message</h3>
      </div>

      <div className="space-y-4">
        <Input
          label="Welcome Message"
          type="text"
          placeholder="You're invited to celebrate the wedding of"
          value={welcome.message || ''}
          onChange={(e) => updateWelcome('message', e.target.value)}
        />
        <div className="p-4 bg-muted/30 rounded-lg">
          <p className="text-sm text-muted-foreground mb-2">Preview:</p>
          <p className="text-base text-foreground">
            {welcome.message || "You're invited to celebrate the wedding of"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CmsWelcomeSection;
